import { render, staticRenderFns } from "./MoveModal.vue?vue&type=template&id=4184ffd4"
import script from "./MoveModal.vue?vue&type=script&lang=js"
export * from "./MoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports